/* App */
export const HEARTBEAT = 'HEARTBEAT';
export const SEARCH_LOADING = 'SEARCH_LOADING';
export const BLOCK_HISTORY = 'BLOCK_HISTORY';
export const UNBLOCK_HISTORY = 'UNBLOCK_HISTORY';
export const SET_USER = 'SET_USER';
export const USER_IS_LOADING = 'USER_IS_LOADING';

/* Rules */
export const CREATE_RULE = 'CREATE_RULE';
export const REVERT_RULE = 'REVERT_RULE';
export const CREATE_RULE_SUBMITTING = 'CREATE_RULE_SUBMITTING';
export const CLEAR_ERROR_ON_RULE_CREATION = 'CLEAR_ERROR_ON_RULE_CREATION,';
export const ERROR_ON_RULE_CREATION = 'ERROR_ON_RULE_CREATION';
export const DELETE_RULE = 'DELETE_RULE';
export const RULE_DELETING = 'RULE_DELETING';
export const FETCH_COLUMNS = 'FETCH_COLUMNS';
export const FETCH_RULES = 'FETCH_RULES';
export const MERGE_RULES = 'MERGE_RULES'
export const INACTIVE_RULES_STATUS = 'INACTIVE_RULES_STATUS'
export const ERROR_ON_SCAN = 'ERROR_ON_SCAN';
export const UPDATE_RULES_WORKTAG = 'UPDATE_RULES_WORKTAG';

export const INVALID_WORKTAGS='INVALID_WORKTAGS';
export const INVOKE_WORKTAGS_API='INVOKE_WORKTAGS_API';
export const ERROR_ON_INVOKE_WORKTAGS_API='ERROR_ON_INVOKE_WORKTAGS_API';


/* Stats */
export const FETCH_STATS = 'FETCH_STATS';
export const FETCH_STATS_COLUMNS = 'FETCH_STATS_COLUMNS';
export const SET_STATS_COLUMNS = 'SET_STATS_COLUMNS';
export const SET_STATS_FILTERS = 'SET_STATS_FILTERS';
export const STATS_LOADING = 'STATS_LOADING';

/* Filter Columns */
export const SET_COLUMNS = 'SET_COLUMNS';


/* Filter Rows */
export const SET_FILTERS = 'SET_FILTERS';

// export const ROOT_URL = process.env.API_BASE_URL;
//export const ROOT_URL = 'http://localhost:3000';
export const RULES_API_NAME = process.env.REACT_APP_API_NAME; //'DevRulesEngineAPI';

export const STATUSES = {
    LOADING: "LOADING",
    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
}

/* Export each action file below */
export * from './actions-app';
export * from './actions-rules';
export * from './actions-filter-columns';
export * from './actions-datagrid';
export * from './actions-stats';


// WEBPACK FOOTER //
// ./src/actions/index.js